// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_diff_lib_index_mjs"], function() { return __webpack_require__("./vendor/decidim-gems/decidim-accountability/app/packs/entrypoints/decidim_accountability.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
